(() => {
  if (window.jdmCollectionRowsReady) return;
  window.jdmCollectionRowsReady = true;
  const tracks = [
    ['badges', '.jdm-card-badges', 4],
    ['swatches', '.jdm-card-swatch-row', 6],
    ['topIcons', '.jdm-card-top-icons', 4],
    ['vendor', '.jdm-card-vendor', 4],
    ['identity', '.jdm-card-identity', 6],
    ['extras', '.jdm-card-extras', 6],
    ['price', '.jdm-card-price-track', 4],
    ['reviews', '.jdm-card-review-slot', 0],
    ['bottomIcons', '.jdm-card-bottom-icons', 0]
  ];
  let grid, container, frame = 0, lastWidth = -1;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const gridObserver = new MutationObserver(schedule);
  const containerObserver = new MutationObserver(() => { bind(); schedule(); });
  const resizeObserver = new ResizeObserver(entries => {
    const width = entries[0]?.contentRect.width;
    if (width !== lastWidth) { lastWidth = width; schedule(); }
  });
  const financingSizes = new Map();
  const financingObserver = new ResizeObserver(entries => {
    let changed = false;
    for (const entry of entries) {
      if (!financingSizes.has(entry.target)) continue;
      const previous = financingSizes.get(entry.target);
      const size = [entry.contentRect.width, entry.contentRect.height];
      if (!previous || size.some((value, index) => Math.abs(value - previous[index]) > 0.1)) {
        financingSizes.set(entry.target, size);
        changed = true;
      }
    }
    if (changed) schedule();
  });
  function bindFinancing() {
    const current = new Set(grid?.querySelectorAll('.jdm-card-financing') || []);
    for (const element of financingSizes.keys()) {
      if (current.has(element)) continue;
      financingObserver.unobserve(element);
      financingSizes.delete(element);
    }
    for (const element of current) {
      const targetId = element.querySelector('input[name="id"]')?.value;
      const terms = element.querySelector('shopify-payment-terms');
      if (targetId && terms && terms.getAttribute('variant-id') !== targetId) {
        terms.setAttribute('variant-id', targetId);
      }
      if (financingSizes.has(element)) continue;
      financingSizes.set(element, null);
      financingObserver.observe(element);
    }
  }
  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }
  function bind() {
    const nextContainer = document.querySelector('.jdm-collection-grid-section #ProductGridContainer');
    if (container !== nextContainer) {
      containerObserver.disconnect(); container = nextContainer;
      if (container) containerObserver.observe(container, { childList: true });
    }
    const nextGrid = container?.querySelector('#product-grid');
    if (nextGrid !== grid) {
      gridObserver.disconnect(); resizeObserver.disconnect(); grid = nextGrid; lastWidth = -1;
      if (grid) {
        gridObserver.observe(grid, { childList: true, characterData: true, subtree: true });
        resizeObserver.observe(grid);
      }
    }
    bindFinancing();
  }
  function update() {
    frame = 0; bind(); if (!grid) return;
    const cards = [];
    for (const item of grid.children) {
      const card = item.querySelector('.jdm-collection-card');
      if (!card || !item.getClientRects().length) continue;
      const elements = tracks.map(([key, selector, gap]) => ({ key, gap, element: card.querySelector(selector) }));
      for (const { element } of elements) if (element) element.classList.add('jdm-row-track');
      card.classList.add('jdm-row-measuring');
      cards.push({ item, card, elements });
    }
    const rows = [];
    for (const entry of cards) {
      const top = entry.item.offsetTop;
      let row = rows.find(r => Math.abs(r.top - top) <= 2);
      if (!row) { row = { top, cards: [], maxima: {} }; rows.push(row); }
      row.cards.push(entry);
      for (const track of entry.elements) {
        const height = track.element?.getBoundingClientRect().height || 0;
        row.maxima[track.key] = Math.max(row.maxima[track.key] || 0, height);
      }
    }
    for (const row of rows) {
      for (const { card, elements } of row.cards) {
        for (const { key, gap, element } of elements) {
          if (!element) continue;
          const natural = Math.ceil(row.maxima[key] * 100) / 100;
          const spacing = natural > 0 ? gap : 0;
          setProperty(element, '--jdm-track-height', `${natural + spacing}px`);
          setProperty(element, '--jdm-track-gap', `${spacing}px`);
          if (key === 'reviews' && natural === 0) setProperty(element, '--jdm-review-offset', '0px');
        }
        card.classList.remove('jdm-row-measuring');
      }
    }
    for (const row of rows) {
      const reviewTracks = row.cards.map(({ card }) => ({ card, element: card.querySelector('.jdm-card-review-slot') })).filter(track => track.element);
      if (!row.maxima.reviews || !reviewTracks.length) continue;
      const positions = reviewTracks.map(({ card, element }) => ({ element, top: element.getBoundingClientRect().top - card.getBoundingClientRect().top - (parseFloat(element.style.getPropertyValue('--jdm-review-offset')) || 0) }));
      const lowest = Math.max(...positions.map(position => position.top));
      for (const { element, top } of positions) setProperty(element, '--jdm-review-offset', `${Math.max(0, Math.round((lowest - top) * 100) / 100)}px`);
    }
  }
  document.addEventListener('shopify:section:load', () => { bind(); schedule(); });
  document.addEventListener('load', event => { if (event.target.tagName === 'IMG' && grid?.contains(event.target)) schedule(); }, true);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  bind(); schedule();
})();
